/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SessionDto } from '../../models/session-dto';

export interface SuperadminControllerImpersonate$Params {
  uuid: string;
}

export function superadminControllerImpersonate(http: HttpClient, rootUrl: string, params: SuperadminControllerImpersonate$Params, context?: HttpContext): Observable<StrictHttpResponse<SessionDto>> {
  const rb = new RequestBuilder(rootUrl, superadminControllerImpersonate.PATH, 'post');
  if (params) {
    rb.path('uuid', params.uuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SessionDto>;
    })
  );
}

superadminControllerImpersonate.PATH = '/superadmin/users/{uuid}/impersonate';
